if (!customElements.get('change-text-tabs')) {
  customElements.define(
    'change-text-tabs',
    class ChangeTextTabs extends HTMLDivElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.changeTextButtons = this.querySelectorAll('.change-text-button');
        this.changeTextContents = this.querySelectorAll('.change-text-content');
        this.currentIndex = 0;
        this.init();
      }

      init() {
        // 为每个按钮添加点击事件
        this.changeTextButtons.forEach((btn, index) => {
          btn.addEventListener('click', this.onClick.bind(this));
          // 设置初始状态
          if (index === 0) {
            btn.classList.add('is-active');
          } else {
            btn.classList.remove('is-active');
          }
        });

        // 设置初始内容显示状态
        this.changeTextContents.forEach((content, index) => {
          if (index === 0) {
            content.style.display = 'block';
          } else {
            content.style.display = 'none';
          }
        });

        // 在Shopify主题编辑器中支持block选择
        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (e) => {
            const targetBlock = e.detail.target;
            const controlId = targetBlock.dataset.controlId;
            if (controlId) {
              this.setActiveTabByControlId(controlId);
            }
          });
        }
      }

      onClick(e) {
        e.preventDefault();
        const { target } = e;
        const button = target.closest('.change-text-button');
        if (!button) return;
        
        const controlId = button.dataset.controlId;
        this.setActiveTabByControlId(controlId);
      }

      setActiveTabByControlId(controlId) {
        // 找到对应的按钮和内容
        const targetButton = this.querySelector(`.change-text-button[data-control-id="${controlId}"]`);
        const targetContent = this.querySelector(`.change-text-content[data-control-id="${controlId}"]`);
        
        if (!targetButton || !targetContent) return;

        // 移除所有按钮的active状态
        this.changeTextButtons.forEach(btn => {
          btn.classList.remove('is-active');
        });

        // 隐藏所有内容
        this.changeTextContents.forEach(content => {
          content.style.display = 'none';
        });

        // 激活目标按钮和内容
        targetButton.classList.add('is-active');
        targetContent.style.display = 'block';

        // 触发自定义事件
        this.dispatchEvent(
          new CustomEvent('changeTextTabChange', {
            bubbles: true,
            detail: { 
              selectedControlId: controlId, 
              selectedButton: targetButton,
              selectedContent: targetContent 
            },
          })
        );
      }

      setActiveTab(index) {
        if (this.currentIndex === index) return;

        // 移除当前active状态
        this.changeTextButtons[this.currentIndex].classList.remove('is-active');
        this.changeTextContents[this.currentIndex].style.display = 'none';

        // 设置新的active状态
        this.changeTextButtons[index].classList.add('is-active');
        this.changeTextContents[index].style.display = 'block';

        this.currentIndex = index;

        // 触发自定义事件
        this.dispatchEvent(
          new CustomEvent('changeTextTabChange', {
            bubbles: true,
            detail: { 
              selectedIndex: index, 
              selectedButton: this.changeTextButtons[index],
              selectedContent: this.changeTextContents[index] 
            },
          })
        );
      }
    },
    { extends: 'div' }
  );
} 